<h1 *header="'Partner Affiliations'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>

<app-signup-header></app-signup-header>

<ng-container *ngIf="(Affiliations$ | async) as affiliations; else loading">
  <p>
    According to our records, you are affiliated with the organization(s) listed below. If you are still with the
    organization and nothing needs to change, select "Next." If you are no longer with the organization, please click
    <button type="button" class="btn btn-xs btn-danger"> <fa-icon [icon]="faXmark"></fa-icon> <span
        class="sr-only">Delete</span></button> to remove the relationship.
  </p>

  <ng-container *ngFor="let alert of Alerts">
    <alert [type]="alert.type" [dismissible]="true" [dismissOnTimeout]="10000" (onClosed)="alertOnClosed(alert);">
      <p [innerHTML]="alert.msg"></p>
    </alert>
  </ng-container>

  <fieldset bsMigration [bs3Class]="['panel-default']" class="panel">
    <legend bsMigration class="panel-heading">
      Relationships
    </legend>
    <div bsMigration class="panel-body">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <th>Organization</th>
            <th>Start Date</th>
            <th>Relationship</th>
            <th>Group?</th>
            <th><span class="sr-only">Actions</span></th>
          </thead>
          <tbody>
            <tr *ngFor="let affiliation of affiliations" [ngClass]="{'warning': Busy.has(affiliation)}">
              <td>{{ affiliation.org_name }}</td>
              <td>{{ affiliation.ixo_start_date | date:'mediumDate' }}</td>
              <td>{{ affiliation.rlt_code }}</td>
              <td>{{ affiliation.org_group_aie_flag_ext ? 'Yes' : 'No' }}</td>
              <td>
                <button type="button" class="btn btn-danger" (click)="Delete(affiliation);"
                  [disabled]="Busy.has(affiliation)">
                  <fa-icon [icon]="faXmark"></fa-icon> <span class="sr-only">Delete</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        <strong>Please Note:</strong> These are not Additional Insured Endorsements (AIE). You will be asked to manage
        your AIEs later.
      </p>
    </div>
  </fieldset>

  <p>
    Need to add a new affinity before continuing? Contact us at {{ Settings.site_phone }} or <a
      [href]="'mailto:' + Settings.site_mail">{{ Settings.site_mail }}</a>.
  </p>

  <p>
    <button type="button" class="btn btn-primary btn-lg" (click)="Save()">Next</button>
  </p>
</ng-container>

<ng-template #loading>
  <p>Loading...</p>
</ng-template>

<aside bsModal #confirm="bs-modal" class="modal fade" (onHidden)="confirmModalClose()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <strong>{{ confirm.config.initialState ? confirm.config.initialState['org_name'] : null }}</strong>
      </div>
      <div class="modal-body">
        <p>This organization is part of a group owned by a single entity. <strong>Removing this relationship will remove
            every organization in the group.</strong> Please proceed with caution. If you have questions, please contact
          us directly for assistance at {{ Settings.site_phone }} or <a
            [href]="'mailto:' + Settings.site_mail">{{ Settings.site_mail }}</a>.</p>
        <p><strong>Are you sure you want to remove every organization under this group?</strong></p>
        <p class="text-center">
          <button type="button" class="btn btn-danger" (click)="Delete($any(confirm.config.initialState), true)">Yes</button>
          <button type="button" class="btn btn-primary" (click)="confirm.hide()">No</button>
        </p>
      </div>
    </div>
  </div>
</aside>
